import "@refinedev/antd/dist/reset.css";
import "./global.css";

import { router as adminRouter } from "admin/src/router";
import { router as deskRouter } from "desk/src/router";
import { router as invitationRouter } from "invitation/src/router";
import { RouterProvider } from "react-router-dom";

function App() {
  return (
    <>
      <RouterProvider router={adminRouter} />
      <RouterProvider router={deskRouter} />
      <RouterProvider router={invitationRouter} />
    </>
  );
}

export default App;
